import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSmartComponent } from './simple-icons-smart.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSmartComponent ],
    exports:      [ SimpleIconsSmartComponent ],
    bootstrap:    []
})
export class SimpleIconsSmartModule {}
